import { render, staticRenderFns } from "./ProjectDependencies.vue?vue&type=template&id=4236bb86&"
import script from "./ProjectDependencies.vue?vue&type=script&lang=js&"
export * from "./ProjectDependencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports